import { docStatuses } from "src/api/config/systemSwitch";
import { Send, Check, Clock, Close, Modification, Pencil, ArchiveAddIcon } from "src/components/ui-icons/card";

type Props = {
    statuses: { ID: number, Title: string }[]
}

const HistoryStatuses = (props: Props) => {

    const { statuses } = props;

    return (
        <div className="flex items-center text-sm text-[#111928]">
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.agreed || item.get_lookupId() === docStatuses.approved || item.get_lookupId() === docStatuses.public) &&
                <Check />
            }
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.sendApproval) &&
                <Send />
            }
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.edited) && statuses.filter((item: any) => item.get_lookupId() === docStatuses.sendApproval).length === 0 && statuses.filter((item: any) => item.get_lookupId() === docStatuses.sendRevision).length === 0 &&
                <Pencil />
            }
            {(statuses.some((item: any) => item.get_lookupId() === docStatuses.waitApproval) || statuses.some((item: any) => item.get_lookupId() === docStatuses.review)) &&
                <Clock />
            }
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.cancel) &&
                <Close />
            }
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.sendRevision) &&
                <Modification />
            }
            {statuses.some((item: any) => item.get_lookupId() === docStatuses.sendArchive) &&
                <ArchiveAddIcon />
            }
            &nbsp;&nbsp;{statuses.map((item: any, idx: number) => (
                <>
                    {idx < statuses.length - 1 &&
                        <span>{item.get_lookupValue()},&nbsp;</span>
                        ||
                        <span>{item.get_lookupValue() === 'На пересмотр' && 'Отправлен на пересмотр' || item.get_lookupValue()}</span>
                    }
                </>
            ))}
        </div>
    );
};

export default HistoryStatuses;
